import Model from '@/models/Model'

export default class ARestore extends Model {
    resource() {
        return 'restore'
    }
}